import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  getFilteredRowModel,
  getSortedRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel
} from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { CartState } from '../Context/Context';
import { CalculateTableArray, DatefilterFn, Filter, SingleDateFilterFn, convertToLocalDate, dateformatDDMMYEAR, downloadCSV, handleDownload } from '../utils/Utils';
import PopupBanner from '../components/PopupBanner';
import { useSearchParams } from 'react-router-dom'

const Notification = () => {
  const location = useLocation();
  const loc = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('userData'));
  const [searchParams]  = useSearchParams()
  const poNumber = searchParams.get('po');

  const {
    state: { notifyData, count },
    changeNotificationStaus,
    getNotificationListForBuyer,
    getNotificationListForSupplier
  } = CartState();

  const [columnFilters, setColumnFilters] = useState(
    JSON.parse(localStorage.getItem('column_filters')) ?? []
  );

  const [ClearState, setClearState] = useState(false)

  const [sorting, setSorting] = useState([]);

  const [data, setData] = useState([]);
  const [showSuccessBanner, setShowSuccessBanner] = useState(false)
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)
  // const [pagination, setPagination] = useState({
  //   pageIndex: 0,
  //   pageSize: 10
  // })
  // const { pageIndex, pageSize } = pagination

  useEffect(() => {
    if (!user) return;

    if (user?.roleName === 'BUYER_ROLE') {
      getNotificationListForBuyer(user?.email);
    } else {
      getNotificationListForSupplier(user?.supplierId);
    }
  }, []);

  useEffect(() => {
    setData(notifyData ?? []);
  }, [notifyData]);

  useEffect(() => {
    if (poNumber) {
      setColumnFilters((prev) => [
        ...prev.filter((filter) =>filter.id !== 'Po Number'),
        {
          id: 'Po Number',
          value: [poNumber],
        },
      ]);
    }
  }, [poNumber]);


  const { t } = useTranslation();
  const {
    Notification1,
    Home,
    HFTID,
    CreatedDate,
    CreatedBy,
    Details,
    ClearFilters, Show, Gotopage, Page, MarkAsRead
  } = t('NotificationPage');
  const changeNavigation = (type, hftID) => {
    const data =
      user?.roleName === 'BUYER_ROLE'
        ? type?.toLowerCase() === 'urgent'
          ? '/buyer/urgent_orders/request_details'
          : '/buyer/hft_buyer_change_requests/request_details'
        : type?.toLowerCase() === 'urgent'
          ? '/vendor/urgent_orders/request_details'
          : '/vendor/po_change_requests/request_details';
    return data + '/' + hftID;
  };

  // useEffect(() => { }, [notifyData, count]);

  const [selectedRows, setSelectedRows] = useState({});


  const headers = {
    HFTID: t('NotificationPage.HFTID'),
    PONUMBER: t('NotificationPage.PONumber'),
    CreatedDate: t('NotificationPage.CreatedDate'),
    CreatedBy: t('NotificationPage.CreatedBy'),
    Details: t('NotificationPage.Details'),
    Notification1: t('NotificationPage.NotificationType'),
    ActionTaken: t('NotificationPage.ActionTaken'),
    STATUS: t('NotificationPage.Status')
  };

  const columns = useMemo(
    () => [
      {
        id: "select",
        enableSorting: false,
        enableColumnFilter: false,
        header: ({ table }) => (
          <input
            type="checkbox"
            checked={table.getIsAllPageRowsSelected()}
            onChange={table.getToggleAllPageRowsSelectedHandler()}
          />
        ),
        cell: ({ row }) => {
          return (
            <input
              type="checkbox"
              checked={row.getIsSelected()}
              onChange={row.getToggleSelectedHandler()}
            />
          )
        },
        size: 30
      },
      {
        header: headers.HFTID,
        accessorFn: row => {
          const v = row.iDOpenRequestID;
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          const requestId = row?.original?.iDOpenRequestID;
        
          if (!requestId) {
            return <span className="px-2 py-2">{requestId || ''}</span>;
          }
        
          return (
            <Link
              className="px-2 py-2 underline cursor-pointer text-blue-500"
              to={changeNavigation(
                row?.original?.type,
                requestId
              )}
              onClick={() =>
                changeNotificationStaus([
                  row?.original?.iDNOTIFICATION
                ])
              }
            >
              {requestId}
            </Link>
          );
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
        size: 100
      },
      user?.roleName !== "BUYER_ROLE" && {
        header: headers.PONUMBER,
        accessorFn: row => {
          const v = row.poNumber;

          return !v || v.trim() === ""
            ? "BLANK"
            : v;
        },
        cell: ({ row }) => {
          const poNumber = row?.original?.poNumber;
          const isBlank = !poNumber || poNumber.trim() === "";
      
          return (
            <div className="flex items-center justify-center gap-2 w-full">
              {!isBlank && (
                <>
                  <Link
                    className="underline cursor-pointer text-blue-500"
                    onClick={() =>
                      handleDownload(
                        poNumber,
                        setShowSuccessBanner,
                        setMessage,
                        setLoading
                      )
                    }
                  >
                    {poNumber}
                  </Link>
                  <svg
                    className="w-4 h-4 cursor-pointer"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 16 18"
                    onClick={() =>
                      handleDownload(
                        poNumber,
                        setShowSuccessBanner,
                        setMessage,
                        setLoading
                      )
                    }
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M8 1v11m0 0 4-4m-4 4L4 8m11 4v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3"
                    />
                  </svg>

                </>
              )}
      
              {isBlank && <span> </span>}
            </div>
          );
        },
      
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id);
          return value.includes(cellValue);
        },
        size: 100
      },
      {
        header: headers.CreatedDate,
      
        accessorFn: row => {
          const v = row.createdDate;

          return !v || v.trim() === ""
            ? "BLANK"
            : v;
        },
        cell: ({ getValue }) => {
          const value = getValue();
      
          return !value || value === ' '
            ? ''
            : convertToLocalDate(value);
        },
        filterFn: SingleDateFilterFn,
      
        size: 100
      },
      {
        header: headers.CreatedBy,
      
        accessorFn: row => {
          const v = row.cREATEDBY;

          return !v || v.trim() === ""
            ? "BLANK"
            : v;
        },
        cell: ({ row }) => {
          const value = row.original?.cREATEDBY;

          return !value || value.trim() === ""
            ? null
            : value;
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id);
          return value.includes(cellValue);
        },
        size: 100
      },
      {
        header: headers.Details,
        accessorFn: row => {
          const v = row.dESCRIPTION;
          return !v || v.trim() === ""
            ? "BLANK"
            : v;
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id);

          return value.includes(cellValue);
        },
        size: 350,
      },

      user?.roleName !== "BUYER_ROLE" && {  
        header: headers.STATUS,
        accessorFn: row => {
          const v = row.poStatus;

          return !v || v.trim() === ""
            ? "BLANK"
            : v;
        },
        cell: ({ row }) => {
          const value = row.original?.poStatus;

          return !value || value.trim() === ""
            ? null
            : value;
        },
        filterFn: (row, id, filterValue) => {
          const cellValue = row.getValue(id);
        
          if (!cellValue || !filterValue) return false;
        
          const selectedValues = String(filterValue)
            .split(",")
            .map(value => value.trim().toLowerCase());
  
          return selectedValues.includes(
            String(cellValue).trim().toLowerCase()
          );
        },
        size: 100
      },
      {
        header: headers.ActionTaken,

        accessorFn: row => {
          const v = row.dESCRIPTION;
          const message =
            row.dESCRIPTION?.toLowerCase();
          const match = message?.match(
            /(created|accepted|rejected|edited|cancelled)/i
          );

          if (
            match &&
            row?.type?.toLowerCase() === "po"
          ) {
            return "CANCELLED-PO";
          }
          return match
            ? match[1].toUpperCase()
            : "UNKNOWN";
        },
        cell: ({ row }) => {
          const message =
            row.original?.dESCRIPTION?.toLowerCase();
          const match = message?.match(
            /(created|accepted|rejected|edited|cancelled)/i
          );
          if (
            match &&
            row?.original?.type?.toLowerCase() === "po"
          ) {
            return "CANCELLED-PO";
          }
          return match
            ? match[1].toUpperCase()
            : "UNKNOWN";
        },
        filterFn: (row, id, filterValue) => {
          const cellValue = row.getValue(id);
        
          if (!cellValue || !filterValue) return false;
        
          const selectedValues = String(filterValue)
            .split(",")
            .map(value => value.trim().toLowerCase());
  
          return selectedValues.includes(
            String(cellValue).trim().toLowerCase()
          );
        },
        size: 100,
      },
      {
        id: "Notification1",

        header: headers.Notification1,

        accessorFn: (row) => {
          const v = row.type;

          return !v || v.trim() === ""
            ? "BLANK"
            : v;
        },

        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id);

          // // Check if cellValue is null or undefined before calling toString()
          if (cellValue == null) {
            return false; // or any other logic you want to apply when the value is null
          }
          let words = value
            .split(/[\s,]+/)
            .map((word) => word.toLowerCase());

          return words.includes(
            cellValue?.toLowerCase()
          );
       },
       size: 100
      },
    ].filter(Boolean),
  [headers, user?.roleName]
  );
  // const handlePageChange = (pageIndex) => {
  //   setPagination((prev) => ({
  //     ...prev,
  //     pageIndex
  //   }))
  // }

  const table = useReactTable({
    data,
    columns,
    state: {
      columnFilters,
      sorting,
      rowSelection: selectedRows,
      // pagination
    },
    enableRowSelection: (row) => {
      return row.original.status !== "Y";
    },
    onRowSelectionChange: setSelectedRows,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    onColumnFiltersChange: setColumnFilters,
    onSortingChange: setSorting,
    getPaginationRowModel: getPaginationRowModel(),
    // manualPagination: true,
    // pageCount: data?.totalPages ?? 0,
  });



  const generateCSVData = (table) => {
    const data = table?.getFilteredRowModel()?.rows?.map((row) => {
      return row?.original
    })
    return data
  }


  const cleared = () => {
    const localStorageKey = 'all_selected_values';
    localStorage.removeItem(localStorageKey);
    setColumnFilters([])
    setClearState(prevState => !prevState); // Toggle the state
  }
  //error message 
  const [errorMessage, setErrorMessage] = useState(null);
  // Retrieve the role from localStorage
  const role = localStorage.getItem('role');
  if (!role) return null; // Return null if no role is found

  // Function to navigate based on the user's role
  const navigateRolePage = () => {
    let path = '';
    if (role === 'buyer') {
      path = `/buyer`;
    } else if (role === 'vendor') {
      path = `/vendor`;
    } else {
      setErrorMessage("Invalid role"); // Set error message if role is invalid
      return;
    }
    navigate(path); // Navigate to the specified path
  };

  const readAllNotifications = async () => {
    const data = notifyData?.map(no => no?.iDNOTIFICATION) || [];

    try {
      await changeNotificationStaus(data);
      navigateRolePage()
    } catch (err) {
      console.error("Error updating notifications:", err);
    }
  };

  const readSelectedNotifications = async () => {
    const selectedData = table
      .getSelectedRowModel()
      .rows
      .map((r) => r.original);

    const data = selectedData?.map(no => no?.iDNOTIFICATION) || [];

    try {
      await changeNotificationStaus(data);
      setSelectedRows({});
    } catch (err) {
      console.error("Error updating notifications:", err);
    }
  };
  const selected = table
    .getSelectedRowModel()
    .rows
    .map((r) => r.original)


  return (
    <main className='w-full flex flex-col gap-3 p-3 h-full'>
      <div className='w-full justify-between flex items-center'>
        <div>
          <p className='text-xl font-medium'>{Notification1}</p>
        </div>
      </div>
      <div className='w-full text-xs flex justify-start items-center gap-1 font-medium text-gray-600'>
        <p className='flex gap-1 items-center justify-center'>
          <span
            className='hover:underline cursor-pointer'
            onClick={() => navigateRolePage(role)}
          >
            {Home}
          </span>
          <span>{'>'}</span>
        </p>
        <p className='flex gap-1 items-center justify-center'>
          <span>{Notification1}</span>
        </p>
      </div>

      <div className='w-full flex items-center justify-end text-xs mt-4'>
      <div className='flex items-center gap-2'>
        {columnFilters?.length > 0 && (
          <button
            className='font-medium text-white outline-none bg-[#415da1] w-[90px] rounded-md h-[30px]'
            onClick={() => {
              cleared()
            }}
          >
            {ClearFilters}
          </button>
        )}
        {/* {data?.length !== 0 && downloadCSV('PO_list', generateCSVData(table))} */}
        {/* <button
          onClick={() => readAllNotifications()}
          className="border p-2 font-medium text-xs bg-blue-600 text-white rounded hover:bg-blue-700 text-sm transition disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed disabled:hover:bg-gray-300"
          disabled={selected?.length > 0}
        >
          Read All
        </button> */}
        <button
          onClick={() => readSelectedNotifications()}
          className="border p-2 font-medium text-xs 
    bg-blue-600 text-white rounded 
    hover:bg-blue-700 text-sm 
    transition

    disabled:bg-gray-300
    disabled:text-gray-500
    disabled:border-gray-300
    disabled:cursor-not-allowed
    disabled:hover:bg-gray-300"
          disabled={selected?.length === 0}
        >
          {MarkAsRead}
        </button>
        <button
          className='border rounded p-1 font-medium text-sm'
            // onClick={() => handlePageChange(0)}
            onClick={() => table.setPageIndex(0)}
          disabled={!table.getCanPreviousPage()}
        >
          {'<<'}
        </button>
        <button
          className='border rounded p-1 font-medium text-sm'
          // onClick={() => handlePageChange(pagination.pageIndex - 1)  }
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          {'<'}
        </button>
        <button
          className='border rounded p-1 font-medium text-sm'
          // onClick={() =>  handlePageChange(pagination.pageIndex + 1)  }
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          {'>'}
        </button>
        <button
          className='border rounded p-1 font-medium text-sm'
          // onClick={() => handlePageChange(data?.totalPages - 1) }
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}
        >
          {'>>'}
        </button>
        <span className='min-w-max flex items-center gap-1'>
          <div>{Page}</div>
          <strong>
            {table.getState().pagination.pageIndex + 1} of{' '}
            {table.getPageCount()}
          </strong>
        </span>
        <span className='min-w-max flex items-center gap-1'>
          | | {Gotopage}
          <input
            type='number'
            id='pagination_input'
            name='pagination_input'
            value={table.getState().pagination.pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              table.setPageIndex(page)
            }}
            className='border p-1 rounded w-16'
          />
        </span>
        <select
          className='border border-gray-300 rounded-md p-1 outline-none'
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value))
          }}
        >
          {CalculateTableArray(table?.getFilteredRowModel()?.rows?.length).map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {Show} {pageSize}
            </option>
          ))}
        </select>
        </div>
      </div>


      {/* <div className='w-full border border-gray-300 text-xs my-4'> */}
      {notifyData?.length !== 0 ? (
        <>
          <div className='w-full overflow-x-auto' style={{ minHeight: "70vh", minWidth: "660px", }}>
            <table className='w-full text-xs border border-gray-300 relative'>
              <thead className='sticky top-0 z-10'>
                {table.getHeaderGroups()?.map((headerGroup) => (
                  <tr
                    key={headerGroup.id}
                    className='divide-x-[1px] bg-[#e0ecfc] divide-gray-300 border-[#ccd9e4] border'
                  >
                    {headerGroup.headers?.map((header) => (
                      <th
                        key={header.id}
                        className='font-medium px-2 py-3'
                        style={{ width: header.getSize() }}
                      >
                        {header.isPlaceholder ? null : (
                          <div
                            className={
                              header.column.getCanSort()
                                ? "cursor-pointer select-none"
                                : "cursor-default"
                            }
                            onClick={
                              header.column.getCanSort()
                                ? header.column.getToggleSortingHandler()
                                : undefined
                            }
                          >
                            <div className='flex justify-center h-5 items-center'>
                              {flexRender(header.column.columnDef.header, header.getContext())}
                              &nbsp;&nbsp;
                              {header.column.getCanSort() && <div>
                                {{
                                  asc: (
                                    <svg
                                      className='w-3 h-4 text-gray-500'
                                      aria-hidden='true'
                                      xmlns='http://www.w3.org/2000/svg'
                                      fill='none'
                                      viewBox='0 0 10 14'
                                    >
                                      <path
                                        stroke='currentColor'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        strokeWidth='2'
                                        d='M5 13V1m0 0L1 5m4-4 4 4'
                                      />
                                    </svg>
                                  ),
                                  desc: (
                                    <svg
                                      className='w-3 h-4 text-gray-500'
                                      aria-hidden='true'
                                      xmlns='http://www.w3.org/2000/svg'
                                      fill='none'
                                      viewBox='0 0 10 14'
                                    >
                                      <path
                                        stroke='currentColor'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        strokeWidth='2'
                                        d='M5 1v12m0 0 4-4m-4 4L1 9'
                                      />
                                    </svg>
                                  )
                                }[header.column.getIsSorted()] ?? (
                                    <svg
                                      className='w-3 h-4 text-gray-500'
                                      aria-hidden='true'
                                      xmlns='http://www.w3.org/2000/svg'
                                      fill='none'
                                      viewBox='0 0 16 20'
                                    >
                                      <path
                                        stroke='currentColor'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        strokeWidth='2'
                                        d='M4 6v13m0 0 3-3m-3 3-3-3m11-2V1m0 0L9 4m3-3 3 3'
                                      />
                                    </svg>
                                  )}
                              </div>}
                            </div>
                          </div>
                        )}
                        {header.column.getCanFilter() ? (
                          <div>
                            <Filter
                              column={header.column}
                              table={table}
                              columnFilters={columnFilters}
                              HeaderText={header.column.columnDef.header}
                              header={header}
                              ClearState={ClearState}
                            />
                          </div>
                        ) : null}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => {
                  const rowData = row.original;
                  const rowStatus = rowData?.status;
                  return (
                    <tr
                      key={row.id}
                      className={`${rowStatus === 'Y' ? 'bg-purple-50' : 'bg-red-200'} 
                      text-center divide-x-[1px] divide-gray-300 border border-gray-300 text-gray-600`}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td
                          key={cell.id}
                          className='px-2 py-2'
                          style={{ width: cell.column.getSize() }}
                        >
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* <div className='w-full overflow-x-auto min-h-[70%]'>
              <table
                className='text-xs border border-gray-300 relative'
                {...{
                  style: {
                    width: table.getCenterTotalSize(),
                  },
                }}
              >
                <thead className='sticky top-0 z-10'>
                  {table.getHeaderGroups().map((headerGroup, index) => (
                    <tr
                      key={headerGroup.id + index}
                      className='divide-x-[1px] bg-[#e0ecfc] divide-gray-300 border-[#ccd9e4] border'
                    >
                      {headerGroup.headers.map((header) => {
                        const { column } = header;
                        return (
                          <th
                            key={header?.id}
                            className={`font-medium px-2 py-3 sticky top-0 ${header.id === 'PO_SKU' || header.id === 'REQUEST_TYPE' ? 'frozen-column' : ''}`}
                            {...{
                              key: header.id,
                              colSpan: header.colSpan,
                              style: {
                                width: header.getSize(),
                              },
                            }}
                          // style={{ ...getCommonPinningStyles(column, table.getAllColumns()) }}
                          >
                            {header.isPlaceholder ? null : (
                              <div
                                className={header.column.getCanSort() ? 'cursor-pointer select-none' : ''}
                                onClick={header.column.getToggleSortingHandler()}
                              >
                                <div className='flex justify-center items-center'>
                                  {flexRender(header.column.columnDef.header, header.getContext())}
                                  &nbsp;&nbsp;
                                  <div>
                                    {{
                                      asc: (
                                        <svg
                                          className='w-3 h-4 text-gray-500'
                                          aria-hidden='true'
                                          xmlns='http://www.w3.org/2000/svg'
                                          fill='none'
                                          viewBox='0 0 10 14'
                                        >
                                          <path
                                            stroke='currentColor'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            strokeWidth='2'
                                            d='M5 13V1m0 0L1 5m4-4 4 4'
                                          />
                                        </svg>
                                      ),
                                      desc: (
                                        <svg
                                          className='w-3 h-4 text-gray-500'
                                          aria-hidden='true'
                                          xmlns='http://www.w3.org/2000/svg'
                                          fill='none'
                                          viewBox='0 0 10 14'
                                        >
                                          <path
                                            stroke='currentColor'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            strokeWidth='2'
                                            d='M5 1v12m0 0 4-4m-4 4L1 9'
                                          />
                                        </svg>
                                      ),
                                    }[header.column.getIsSorted()] ?? (
                                        <svg
                                          className='w-3 h-4 text-gray-500'
                                          aria-hidden='true'
                                          xmlns='http://www.w3.org/2000/svg'
                                          fill='none'
                                          viewBox='0 0 16 20'
                                        >
                                          <path
                                            stroke='currentColor'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            strokeWidth='2'
                                            d='M4 6v13m0 0 3-3m-3 3-3-3m11-2V1m0 0L9 4m3-3 3 3'
                                          />
                                        </svg>
                                      )}
                                  </div>
                                </div>
                              </div>
                            )}
                            {header.column.getCanFilter() && (
                              <div>
                                <Filter
                                  column={header.column}
                                  table={table}
                                  columnFilters={columnFilters}
                                  HeaderText={header.column.columnDef.header}
                                  header={header}
                                />
                              </div>
                            )}
                          </th>
                        )
                      })}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => {
                    const rowClassName = index % 2 !== 0 ? 'bg-[#ecedf2]' : 'bg-[#ffffff]';
                    return (
                      <tr
                        key={'tr-polist' + index}
                        className={`${rowClassName} text-center divide-x-[1px] divide-gray-300 border border-gray-300 ${row.getIsSelected() ? 'bg-blue-200' : ''}`}
                      >
                        {row.getVisibleCells().map((cell, cellIndex) => {
                          const { column } = cell;
                          return (
                            <td
                              key={cell.id}
                              className={` px-2 py-3 ${cell.column.id === 'PO_SKU' || cell.column.id === 'REQUEST_TYPE' ? 'frozen-column' : ''}
               `}
                              {...{
                                key: cell.id,
                                style: {
                                  width: cell.column.getSize(),
                                },
                              }}
                            // style={{ ...getCommonPinningStyles(column, table.getAllColumns()) }}
                            >
                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                          )
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div> */}
        </>
      ) : (
        ''
      )}
      {/* </div> */}

      {errorMessage && (
        <div className="fixed top-20 left-1/5 w-3/5 bg-red-100 text-red-700 p-4 rounded-lg shadow-md">
          {errorMessage}
        </div>
      )}
      <PopupBanner isOpen={showSuccessBanner} message={message} onCancel={() => setShowSuccessBanner(false)} />

    </main>
  );
};

export default Notification;